// Bauteil-Typ: was ein Teil im Möbel IST — unabhängig davon, wie es heißt.
// `meta.part_type` ersetzt die alte Namenserkennung ("Rückwand", "Tür …") in
// der Montagereihenfolge (editor/assembly.js, app/models/assembly_plan.rb):
// ein umbenanntes Teil fällt damit nicht mehr in die falsche Phase.
//
// Die Wertemenge bleibt bewusst klein: genau die drei Montagephasen, die die
// Sortierung unterscheidet (Korpus → Rückwand → Front). Alles Feinere (Boden,
// Fachboden, Zarge …) steckt bereits in `meta.role` des Generators und spielt
// für die Montage keine Rolle.
//
// Ruby-Gegenstück: AssemblyPlan::PART_TYPES — Änderungen immer auf beiden
// Seiten nachziehen.
export const PART_TYPES = [ "korpus", "rueckwand", "front" ]

// Teile ohne Flag gelten als Korpus (siehe Fallback in assembly.js).
export const DEFAULT_PART_TYPE = "korpus"

// Beschriftungen für das Details-Panel.
export const PART_TYPE_LABELS = {
  korpus: "Korpus",
  rueckwand: "Rückwand",
  front: "Front / Tür"
}

// Gesetzter, gültiger Bauteil-Typ eines Teils — sonst null.
export function partType(part) {
  const value = part?.meta?.part_type
  return PART_TYPES.includes(value) ? value : null
}

// Neues meta mit gesetztem Bauteil-Typ; unbekannte Werte entfernen das Flag
// (das Teil fällt dann wieder auf die Heuristik zurück).
export function withPartType(part, type) {
  const meta = { ...(part?.meta ?? {}) }
  if (PART_TYPES.includes(type)) meta.part_type = type
  else delete meta.part_type
  return meta
}
